// src/context/UserContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchUserAttributes, getCurrentUser } from "@aws-amplify/auth";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getUserDetail = async () => {
      try {
        setLoading(true);
        // Attempt to get current user, will throw if not authenticated
        await getCurrentUser();

        try {
          // Only try to fetch attributes if we got past getCurrentUser
          const userAttributes = await fetchUserAttributes();
          setCurrentUser(userAttributes);
        } catch (attributeError) {
          console.error("Error fetching user attributes:", attributeError);
          setCurrentUser(null);
        }
      } catch (authError) {
        // User is not authenticated - this is an expected case, not an error
        setCurrentUser(null);
      } finally {
        setLoading(false);
      }
    };

    getUserDetail();
  }, []);

  // Method to update user after login
  const updateUser = async () => {
    setLoading(true);
    try {
      const userAttributes = await fetchUserAttributes();
      setCurrentUser(userAttributes);
      return true;
    } catch (error) {
      console.error("Failed to update user:", error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return (
    <UserContext.Provider value={{ currentUser, loading, setCurrentUser, updateUser }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook for accessing user context
export const useUser = () => useContext(UserContext);